import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    retrieve,
    reset,
    showChords,
    hideChords
} from '../../actions/song/show';
import Display from './Display';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    rButton: {
        position: 'absolute',
        top: 5,
        right: 5
    }
});

class Current extends Component {
    static propTypes = {
        error: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        retrieved: PropTypes.object,
        retrieve: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.props.retrieve('/songs/current');
        this.refresh = setInterval(
            () => this.props.retrieve('/songs/current'),
            5000
        );
    }

    componentWillUnmount() {
        this.props.reset();
        clearInterval(this.refresh);
    }

    state = {
        anchorEl: null
    };

    render() {
        const item = this.props.retrieved;
        const {
            showChords,
            setShowChords,
            setHideChords,
            classes
        } = this.props;

        return (
            <div>
                <Link to={`/songs/pick`} className={classes.rButton}>
                    <Button variant="raised" color="primary" size="small">
                        Pick song
                    </Button>
                </Link>

                {item && (
                    <Display
                        showChords={showChords}
                        setShowChords={setShowChords}
                        setHideChords={setHideChords}
                        item={item}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        error: state.song.show.error,
        loading: state.song.show.loading,
        retrieved: state.song.show.retrieved,
        showChords: state.song.show.showChords
    };
};

const mapDispatchToProps = dispatch => {
    return {
        retrieve: id => dispatch(retrieve(id)),
        reset: () => {
            dispatch(reset());
        },
        setShowChords: () => {
            dispatch(showChords());
        },
        setHideChords: () => {
            dispatch(hideChords());
        }
    };
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Current)
);



// WEBPACK FOOTER //
// ./src/components/song/Current.js